// import './font-loading'
import { send_event } from './analytics.js'
import 'jquery'

// Bootstrap Imports
// import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/button';
// import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/offcanvas';
// import 'bootstrap/js/dist/scrollspy';
import 'bootstrap/js/dist/tab';
// import 'bootstrap/js/dist/toast';

// Bootstrap Imports Requiring PopperJS
// import 'bootstrap/js/dist/dropdown';
// import 'bootstrap/js/dist/popover';
// import 'bootstrap/js/dist/tooltip';

import './fontawesome.js'
import GLightbox from "glightbox";

// Partials
// import './nav-menu'
import './slick-slider'
import './gallery-carousel.js'
import './modal'
import './native-modal'
import './anchor-links'
// import './block-accordion'
// import './block-content-list'

;(function($) {
    window.addEventListener('resize', function () {
        console.log(window.innerWidth - document.querySelector('html').clientWidth)
        document.documentElement.style.setProperty('--aka-scroll-bar-width', (window.innerWidth - document.querySelector('html').clientWidth)+'px');
    })
})(jQuery)

jQuery(window).on('load', function () {
	jQuery(".glightbox").on("click", function (e) {
		e.preventDefault();
	});
	const lightbox = GLightbox({
		touchNavigation: true,
		loop: true,
		autoplayVideos: true,
	});
});

